import { useEffect, useRef } from 'react';

import styles from './VideoNewRecord.module.css';
import bgVideo from '../../assets/video/newRecord.webm';

export const VideoNewRecord = ({ delay = 2800 }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.play();
      }
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <div className={styles.bgVideoWrapper}>
      <video ref={videoRef} playsInline muted="muted" loop autoPlay={false}>
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
